import styled from "styled-components";

export const DivGap = styled.div`
    margin-bottom: 2rem;
    `;